import React from 'react';
import { ClientList } from '../components/clients/ClientList';

export const Clients: React.FC = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Liquid Flow Background */}
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-primary-500/20 via-secondary-500/15 to-primary-600/10 rounded-full blur-3xl animate-liquid-flow opacity-60"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-tr from-secondary-500/20 via-primary-500/15 to-secondary-600/10 rounded-full blur-3xl animate-liquid-flow opacity-50" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-primary-400/10 via-secondary-400/10 to-primary-500/10 rounded-full blur-2xl animate-floating opacity-40" style={{ animationDelay: '4s' }}></div>
        
        {/* Floating Particles */}
        <div className="absolute top-20 left-1/4 w-2 h-2 bg-primary-400/60 rounded-full animate-floating" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-40 right-1/3 w-1 h-1 bg-secondary-400/80 rounded-full animate-floating" style={{ animationDelay: '3s' }}></div>
        <div className="absolute bottom-32 left-1/3 w-1.5 h-1.5 bg-primary-300/70 rounded-full animate-floating" style={{ animationDelay: '5s' }}></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-secondary-300/90 rounded-full animate-floating" style={{ animationDelay: '2.5s' }}></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ClientList />
      </div>
    </div>
  );
};
